import './application.css'; 
import { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, NavLink, useNavigate } from 'react-router-dom';

import UserWidget from '../components/userWidget/userWidget'; 

import AppHome from './appPages/appHome/appHome';
import Expense from './appPages/expense/expense';
import Analytics from './appPages/analytics/analytics';
import Reports from './appPages/reports/reports';
import Profile from './appPages/company/profile/profile';
import Teams from './appPages/company/teams/teams';
import CreateCategory from './appPages/expensehub/createCategory/createCategory';
import HubSettings from './appPages/expensehub/hubSettings/hubSettings';

import ExpensibleLogo from '../assets/expensibleLogo/expensibleLogo';
import SpacerBar from '../components/spacerBar/spacerBar';
import DropArrow from '../assets/icons/navigationIcons/dropArrow/dropArrow'

import NavHome from '../assets/icons/navigationIcons/navHome/navHome';
import NavExpense from '../assets/icons/navigationIcons/navExpense/navExpense';
import NavAnalytics from '../assets/icons/navigationIcons/navAnalytics/navAnalytics';
import NavReports from '../assets/icons/navigationIcons/navReports/navReports';
import NavCompany from '../assets/icons/navigationIcons/navCompany/navCompany'
import NavCompanyProfile from '../assets/icons/navigationIcons/navCompanyProfile/navCompanyProfile';
import NavCompanyTeams from '../assets/icons/navigationIcons/navCompanyTeams/navCompanyTeams';
import NavExpenseHub from '../assets/icons/navigationIcons/navExpenseHub/navExpenseHub';
import NavExpenseHubCreateCategory from '../assets/icons/navigationIcons/navExpenseHubCreateCategory/navExpenseHubCreateCategory';
import NavExpenseHubSettings from '../assets/icons/navigationIcons/navExpenseHubSettings/navExpenseHubSettings'
import ExtraMenuItems from '../assets/icons/navigationIcons/extraMenuItems/extraMenuItems';
import MobileActive from '../assets/icons/navigationIcons/mobileActive/mobileActive';
import MobileArrow from '../assets/icons/navigationIcons/mobileArrow/mobileArrow';

export default function Application({loading, user, expenses, filteredExpenses, filteredCategories, userCategories , localAddNewExpense}) {

    const navigate = useNavigate();

    const mobileBreakPoint = window.innerWidth;
    const [mobileApp, SetMobileApp] = useState(false);

    useEffect(() => {
        isMobile(mobileBreakPoint);
    }, []);

    const isMobile = (mobileBreakPoint) => {
        if (mobileBreakPoint < 640) {
            SetMobileApp(true);
        } else {
            SetMobileApp(false);
        }
    };

    const [expandCompanyItems, setExpandCompanyItems] = useState(false);

    const expandCompany = () => {
        setExpandCompanyItems(prev => !prev);
    }

    const [expandExpenseHubItems, setExpandExpenseHubItems] = useState(false);

    const expandExpenseHub = () => {
        setExpandExpenseHubItems(prev => !prev);
    }

    /* Mobile Nav Control Center */

    const [mobileNavIcons, setMobileNavIcons] = useState([
        <NavExpense/>,
        <NavAnalytics/>,
        <NavHome/>,
        <NavReports/>,
        <ExtraMenuItems/>
    ]);

    const [mobileNavLinks, setMobileNavLinks] = useState([
        'expense',
        'analytics',
        '',
        'reports',
        'expenseHub'
    ]);

    //console.log(mobileNavLinks)

    const [mobileNavIdentifiers, setMobileNavIdentifiers] = useState([
        'Expenses',
        'Analytics',
        'Home',
        'Reports',
        'expenseHub'
    ]);

    const [clickedExpandNav, setClickedExpandNav] = useState(false);
    const [bubbleAlign, setBubbleAlign] = useState('center');
    const [toolsAlign, setToolsAlign] = useState('center');
    const [navAlign, setNavAlign] = useState('flex-start');
    const [toolsHeight, setToolsHeight] = useState('11vh');
    const [toolsPadding, setToolsPadding] =  useState('1rem');
    const [expenseHubBubble, setExpenseHubBubble] = useState('var(--primary-color)')
    const [expenseHubActive, setExpenseHubActive] = useState(false);
    const [nestedNav, setNestedNav] = useState(true);
    const [nestedNavExpanded, setNestedNavExpanded] = useState(false);
    const [customerExpand, setCustomerExpand] = useState(false);
    const [expenseSettingsExpand, setExpenseSettingsExpand] = useState(false);

    const navTimeoutsRef = useRef([]);

    const navExpandTimeOut = (updatedIdentifiers) => {
        if (navTimeoutsRef.current.length > 0) {
            navTimeoutsRef.current.forEach(timeoutId => clearTimeout(timeoutId));
            navTimeoutsRef.current = []; // Reset the queue
        }
        if (updatedIdentifiers[2] === 'expenseHub') {
            return;
        }
        
            // Schedule the new collapse timeout
            const newTimeoutId = setTimeout(() => {
                setClickedExpandNav(false);
                setBubbleAlign('center');
                setToolsAlign('center');
                setToolsHeight('11vh');
                setToolsPadding('1rem');
                setExpenseHubActive(false);
                setExpenseHubBubble('var(--primary-color)');
                setExpandExpenseHubItems(false);
            }, 1500);

            // Push the new timeout ID into our array tracker
            navTimeoutsRef.current.push(newTimeoutId);
    };

    const checkExpenseHub = (updatedIdentifiers) => {
        if (updatedIdentifiers[2] === 'expenseHub') {
            setClickedExpandNav(false);
            setExpandExpenseHubItems(true);
            setBubbleAlign('flex-end');
            setToolsAlign('last baseline');
            setToolsHeight('48rem');
            setToolsPadding('3rem');
            setExpenseHubActive(true);
            setExpenseHubBubble('var(--secondary-color-two)');
            setNestedNav(true);
        }
        else {
            setClickedExpandNav(true);
            setBubbleAlign('flex-end');
            setToolsAlign('last baseline');
            setToolsHeight('16rem');
            setToolsPadding('3rem');
            setExpenseHubBubble('var(--primary-color)');
            setExpandExpenseHubItems(false);
            setExpenseHubActive(false);

            
        }
        navExpandTimeOut(updatedIdentifiers);
    }

    /* The nav console's index switcher */
    const mobileNavIndexA = () => {
        setMobileNavIcons(prevIcons => {
        const nextIcons = [...prevIcons];
        [nextIcons[0], nextIcons[2]] = [nextIcons[2], nextIcons[0]];
        return nextIcons;
        });
        setMobileNavLinks(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[0], nextIcons[2]] = [nextIcons[2], nextIcons[0]];
            return nextIcons;
        });
        setMobileNavIdentifiers(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[0], nextIcons[2]] = [nextIcons[2], nextIcons[0]];
            return nextIcons;
        });

        const nextIdentifiers = [...mobileNavIdentifiers];
        [nextIdentifiers[0], nextIdentifiers[2]] = [nextIdentifiers[2], nextIdentifiers[0]];
        
        setMobileNavIdentifiers(nextIdentifiers);

        
        checkExpenseHub(nextIdentifiers);

        if (nextIdentifiers[2] != 'expenseHub') {
            const nextNavLinks = [...mobileNavLinks];
        [nextNavLinks[0], nextNavLinks[2]] = [nextNavLinks[2], nextNavLinks[0]];
        navigate(`/${nextNavLinks[2]}`);
        //console.log(nextNavLinks);
        }

    };

    const mobileNavIndexB = () => {
        setMobileNavIcons(prevIcons => {
        const nextIcons = [...prevIcons];
        [nextIcons[1], nextIcons[2]] = [nextIcons[2], nextIcons[1]];
        return nextIcons;
        });

        setMobileNavLinks(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[1], nextIcons[2]] = [nextIcons[2], nextIcons[1]];
            return nextIcons;
        });
        setMobileNavIdentifiers(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[1], nextIcons[2]] = [nextIcons[2], nextIcons[1]];
            return nextIcons;
        });

        const nextIdentifiers = [...mobileNavIdentifiers];
        [nextIdentifiers[1], nextIdentifiers[2]] = [nextIdentifiers[2], nextIdentifiers[1]];
        
        setMobileNavIdentifiers(nextIdentifiers);

        
        checkExpenseHub(nextIdentifiers);

        if (nextIdentifiers[2] != 'expenseHub') {
            const nextNavLinks = [...mobileNavLinks];
        [nextNavLinks[1], nextNavLinks[2]] = [nextNavLinks[2], nextNavLinks[1]];
        navigate(`/${nextNavLinks[2]}`);
        //console.log(nextNavLinks);
        }
        
    }
        

    const mobileNavIndexC = () => {
        if (expandExpenseHubItems == true) {
            setClickedExpandNav(false);
            setBubbleAlign('center');
            setToolsAlign('center');
            setToolsHeight('11vh');
            setToolsPadding('1rem');
            setExpenseHubActive(false);
            setExpenseHubBubble('var(--primary-color)');
            setExpandExpenseHubItems(false);
            setNestedNav(false);
            setNestedNavExpanded(false);
            setCustomerExpand(false);
            setExpenseSettingsExpand(false);
        } else {
        checkExpenseHub(mobileNavIdentifiers);
        }
        //console.log(mobileNavLinks);
    };

    const mobileNavIndexD = () => {
        setMobileNavIcons(prevIcons => {
        const nextIcons = [...prevIcons];
        [nextIcons[3], nextIcons[2]] = [nextIcons[2], nextIcons[3]];
        return nextIcons;
        });

        setMobileNavLinks(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[3], nextIcons[2]] = [nextIcons[2], nextIcons[3]];
            return nextIcons;
        });
        setMobileNavIdentifiers(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[3], nextIcons[2]] = [nextIcons[2], nextIcons[3]];
            return nextIcons;
        });

        const nextIdentifiers = [...mobileNavIdentifiers];
        [nextIdentifiers[3], nextIdentifiers[2]] = [nextIdentifiers[2], nextIdentifiers[3]];
        
        setMobileNavIdentifiers(nextIdentifiers);

        
        checkExpenseHub(nextIdentifiers);
        
        if (nextIdentifiers[2] != 'expenseHub') {
            const nextNavLinks = [...mobileNavLinks];
        [nextNavLinks[3], nextNavLinks[2]] = [nextNavLinks[2], nextNavLinks[3]];
        navigate(`/${nextNavLinks[2]}`);
        //console.log(nextNavLinks);
        }

    };

    const mobileNavIndexE = () => {
        setMobileNavIcons(prevIcons => {
        const nextIcons = [...prevIcons];
        [nextIcons[4], nextIcons[2]] = [nextIcons[2], nextIcons[4]];
        return nextIcons;
        });
        setMobileNavLinks(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[4], nextIcons[2]] = [nextIcons[2], nextIcons[4]];
            return nextIcons;
        });
        setMobileNavIdentifiers(prevIcons => {
            const nextIcons = [...prevIcons];
            [nextIcons[4], nextIcons[2]] = [nextIcons[2], nextIcons[4]];
            return nextIcons;
        });

        const nextIdentifiers = [...mobileNavIdentifiers];
        [nextIdentifiers[4], nextIdentifiers[2]] = [nextIdentifiers[2], nextIdentifiers[4]];
        
        setMobileNavIdentifiers(nextIdentifiers);

        
        checkExpenseHub(nextIdentifiers);

        if (nextIdentifiers[2] != 'expenseHub') {
            const nextNavLinks = [...mobileNavLinks];
        [nextNavLinks[4], nextNavLinks[2]] = [nextNavLinks[2], nextNavLinks[4]];
        navigate(`/${nextNavLinks[2]}`);
        //console.log(nextNavLinks);
        }

    };

    /* Nested nav logic */

    const expandingCustomer = () => {
        setNestedNav(false);
        setNestedNavExpanded(true);
        setCustomerExpand(true);
        
    }

    const expandingExpenseHub = () => { 
        setNestedNav(false);
        setNestedNavExpanded(true);
        setExpenseSettingsExpand(true);
    }

    const closeNestedNav= () => {
        setNestedNavExpanded(false);
        setExpenseSettingsExpand(false);
        setCustomerExpand(false);
        setNestedNav(true);
    }

    /* active nav class for desktop */

    const [activeHome, setActiveHome] = useState(true);
    const [activeExpense, setActiveExpense] = useState(false);
    const [activeAnalytics, setActiveAnalytics] = useState(false);
    const [activeReports, setActiveReports] = useState(false);
    const [activeCompany, setActiveCompany] = useState(false);
    const [activeProfile, setActiveProfile] = useState(false);
    const [activeTeams, setActiveTeams] = useState(false);
    const [activeHub, setActiveHub] = useState(false);
    const [activeCreateCategory, setActiveCreateCategory] = useState(false);
    const [activeHubSettings, setActiveHubSettings] = useState(false);

    const activeNavLink = () => {
        setActiveHome(false);
        setActiveExpense(false);
        setActiveAnalytics(false);
        setActiveReports(false);
        setActiveCompany(false);
        setActiveProfile(false);
        setActiveTeams(false);
        setActiveHub(false);
        setActiveCreateCategory(false);
        setActiveHubSettings(false);

        /*setExpandCompanyItems(false);
        setExpandExpenseHubItems(false);*/
    }

useEffect(() => {
  const currentDirectory = window.location.pathname;

  activeNavLink();

  if (currentDirectory === '/' || currentDirectory === '/home') {
    setActiveHome(true);
  } else if (currentDirectory === '/analytics') {
    setActiveAnalytics(true);
  } else if (currentDirectory === '/expense') {
    setActiveExpense(true);
  } else if (currentDirectory === '/reports') {
    setActiveReports(true);
  } else if (currentDirectory === '/company') {
    setActiveCompany(true);
  } else if (currentDirectory === '/profile') {
    setActiveProfile(true);
  } else if (currentDirectory === '/teams') {
    setActiveTeams(true);
  } else if (currentDirectory === '/hub') {
    setActiveHub(true);
  } else if (currentDirectory === '/create-category') {
    setActiveCreateCategory(true);
  } else if (currentDirectory === '/hub-settings') {
    setActiveHubSettings(true);
  }
}, []);
    
    

    

    return (
        <div className="application" style={{ '--bubble-clicked-tool': bubbleAlign, '--icons-clicked-tool': toolsAlign, '--container-clicked-tool': toolsHeight, '--container-padding': toolsPadding, '--nav-align': navAlign}}>
            
                <div className="application-container">

                    <div className="application-nav-bar"> 

                        {mobileApp ? 
                        ''
                        :
                        <div className="application-user-widget">
                            <UserWidget user={user} />
                        </div>
                        }

                        <div className="dashboard-navigation">  

                            {mobileApp ? 
                            
                            <div>
                                <div className="dashboard-navigation-expanded">
                                    <div className="dashboard-navigation-expanded-expense-hub">
                                        {clickedExpandNav ? <p className="mobile-nav-identifier">{mobileNavIdentifiers[2]}</p> : ''}
                                    </div>
                                    <div>
                                        {expenseHubActive ? <div className="dashboard-navigation-expanded-expense-hub"><UserWidget user={user}/></div> : ''}
                                        {expenseHubActive ? 
                                            <div className="dashboard-navigation-expanded-expense-hub">
                                                <div className="">
                                                    {nestedNav ?
                                                    <div className="expanded-nav-button-layout">
                                                        <button className="expanded-nav-button" onClick={expandingCustomer}>Customer</button>
                                                        <button className="expanded-nav-button" onClick={expandingExpenseHub}>Expense Hub</button>
                                                    </div>
                                                    :
                                                    ''
                                                    }
                                                    {nestedNavExpanded ? 
                                                    <div className="nested-nav-layout">
                                                        <div onClick={closeNestedNav} className="nav-back-arrow"><MobileArrow/></div>
                                                        {customerExpand ?
                                                        <div className="expanded-nav-button-layout">
                                                            <button className="expanded-nav-button" onClick={mobileNavIndexC}>Profile</button>
                                                            <button className="expanded-nav-button" onClick={mobileNavIndexC}>Teams</button>
                                                        </div>
                                                        :
                                                        ''}

                                                        {expenseSettingsExpand ?
                                                        <div className="expanded-nav-button-layout">
                                                            <NavLink to='expensehub/create-category'><button className="expanded-nav-button" onClick={mobileNavIndexC}>Create Category</button></NavLink>
                                                            <NavLink to='expensehub/hub-settings'><button className="expanded-nav-button" onClick={mobileNavIndexC}>Hub Settings</button></NavLink>
                                                        </div>

                                                        : ''}
                                                        
                                                    </div>
                                                    :
                                                    ''
                                                    }
                                                </div>
                                            </div> 
                                        : ''}
                                    </div>
                                    <div className="dashboard-navigation-tools">
                                        
                                        <div className="dashboard-navigation-links" onClick={mobileNavIndexA}>{mobileNavIcons[0]}</div>
                                        <div className="dashboard-navigation-links" onClick={mobileNavIndexB}>{mobileNavIcons[1]}</div>
                                        <div className="active-navigation-bubble-container" onClick={mobileNavIndexC}>
                                            <MobileActive expenseHubActive={expenseHubBubble}/>
                                            <div className="dashboard-navigation-links active-mobile-icon">{mobileNavIcons[2]}</div>
                                        </div>
                                        <div className="dashboard-navigation-links" onClick={mobileNavIndexD}>{mobileNavIcons[3]}</div>
                                        <div className="dashboard-navigation-links" onClick={mobileNavIndexE}>{mobileNavIcons[4]}</div>
                                        {/*
                                        <NavLink to={`/${mobileNavLinks[0]}`}><div className="dashboard-navigation-links" onClick={mobileNavIndexA}>{mobileNavIcons[0]}</div></NavLink>
                                        <NavLink to={`/${mobileNavLinks[1]}`}><div className="dashboard-navigation-links" onClick={mobileNavIndexB}>{mobileNavIcons[1]}</div></NavLink>
                                        <div className="active-navigation-bubble-container" onClick={mobileNavIndexC}>
                                            <MobileActive expenseHubActive={expenseHubBubble}/>
                                            <NavLink to={`/${mobileNavLinks[2]}`}><div className="dashboard-navigation-links active-mobile-icon">{mobileNavIcons[2]}</div></NavLink>
                                        </div>
                                        <NavLink to={`/${mobileNavLinks[3]}`}><div className="dashboard-navigation-links" onClick={mobileNavIndexD}>{mobileNavIcons[3]}</div></NavLink>
                                        <div className="dashboard-navigation-links" onClick={mobileNavIndexE}>{mobileNavIcons[4]}</div>*/}
                                    </div>
                                </div>
                                

                                {/*<div className={expandCompanyItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container'}>
                                    <button onClick={expandCompany} className="dashboard-navigation-button"><div><NavCompany/><a>Company</a></div><DropArrow/></button>
                                    {expandCompanyItems && <SpacerBar width='94%' center='auto' offsetY='-1rem'/>}
                                    <div className="dashboard-navigation-button-items">
                                        <div className={expandCompanyItems ? 'expand-items' : 'dropped-items'}><NavLink to="/company/profile"><div className="dashboard-navigation-button-child"><NavCompanyProfile/><a>Profile</a></div></NavLink></div>
                                        <div className={expandCompanyItems ? 'expand-items' : 'dropped-items'}><NavLink to="/company/teams"><div className="dashboard-navigation-button-child"><NavCompanyTeams/><a>Teams</a></div></NavLink></div>
                                    </div>
                                </div>

                                <div className={expandExpenseHubItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container'}>
                                    <button onClick={expandExpenseHub} className="dashboard-navigation-button"><div><NavExpenseHub/><a>ExpenseHub</a></div><DropArrow/></button>
                                    {expandExpenseHubItems && <SpacerBar width='94%' center='auto' offsetY='-1rem'/>}
                                    <div className="dashboard-navigation-button-items">
                                        
                                        <div className={expandExpenseHubItems ? 'expand-items' : 'dropped-items'}><NavLink to="/expensehub/create-category"><div className="dashboard-navigation-button-child"><NavExpenseHubCreateCategory/><a>Create Category</a></div></NavLink></div>
                                        <div className={expandExpenseHubItems ? 'expand-items' : 'dropped-items'}><NavLink to="/expensehub/hub-settings"><div className="dashboard-navigation-button-child"><NavExpenseHubSettings/><a>Hub Settings</a></div></NavLink></div>
                                    </div>
                                </div>*/}
                            </div> 
                            
                            : 
                            /* active desktop nav class */
                            <div>
                                <SpacerBar />
                                <div className="dashboard-navigation-tools">
                                    <NavLink to=""><div className={activeHome ? "dashboard-navigation-links-active" : "dashboard-navigation-links"} onClick={() => {activeNavLink(); setActiveHome(true)}}><NavHome/><a>Home</a></div></NavLink>
                                    <NavLink to="expense"><div className={activeExpense ? "dashboard-navigation-links-active" : "dashboard-navigation-links"} onClick={() => {activeNavLink(); setActiveExpense(true)}}><NavExpense/><a>Expense</a></div></NavLink>
                                    <NavLink to="analytics"><div className={activeAnalytics ? "dashboard-navigation-links-active" : "dashboard-navigation-links"} onClick={() => {activeNavLink(); setActiveAnalytics(true)}}><NavAnalytics/><a>Analytics</a></div></NavLink>
                                    {/*<NavLink to="/reports"><div className={activeReports ? "dashboard-navigation-links-active" : "dashboard-navigation-links"} onClick={() => {activeNavLink(); setActiveReports(true)}}><NavReports/><a>Reports</a></div></NavLink>*/}
                                </div>
                                <SpacerBar />

                                    {/* Company profile navigation */}
                                {/*<div className={activeCompany ? ( expandCompanyItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container-nav-active') : (expandCompanyItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container')}>
                                    <button onClick={expandCompany} className="dashboard-navigation-button"><div><NavCompany/><a>Company</a></div><DropArrow/></button>
                                    {expandCompanyItems && <SpacerBar width='94%' center='auto' offsetY='-1rem'/>}
                                    <div className="dashboard-navigation-button-items">
                                        <NavLink to="/company/profile"><div className={activeProfile ? (expandCompanyItems ? 'expand-items-active' : 'dropped-items') : (expandCompanyItems ? 'expand-items' : 'dropped-items')} onClick={() => {activeNavLink(); setActiveCompany(true); setActiveProfile(true)}}><div className="dashboard-navigation-button-child"><NavCompanyProfile/><a>Profile</a></div></div></NavLink>
                                        <NavLink to="/company/teams"><div className={activeTeams ? (expandCompanyItems ? 'expand-items-active' : 'dropped-items') : (expandCompanyItems ? 'expand-items' : 'dropped-items')} onClick={() => {activeNavLink(); setActiveCompany(true); setActiveTeams(true)}}><div className="dashboard-navigation-button-child"><NavCompanyTeams/><a>Teams</a></div></div></NavLink>
                                    </div>
                                </div>*/}

                                <div className={activeHub ? ( expandExpenseHubItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container-nav-active') : (expandExpenseHubItems ? 'dashboard-navigation-button-container-active' : 'dashboard-navigation-button-container')}>
                                    <button onClick={expandExpenseHub} className="dashboard-navigation-button"><div><NavExpenseHub/><a>ExpenseHub</a></div><DropArrow/></button>
                                    {expandExpenseHubItems && <SpacerBar width='94%' center='auto' offsetY='-1rem'/>}
                                    <div className="dashboard-navigation-button-items">
                                        
                                        <NavLink to="expensehub/create-category"><div className={activeCreateCategory ? (expandExpenseHubItems ? 'expand-items-active' : 'dropped-items') : (expandExpenseHubItems ? 'expand-items' : 'dropped-items')} onClick={() => {activeNavLink(); setActiveHub(true); setActiveCreateCategory(true)}}><div className="dashboard-navigation-button-child"><NavExpenseHubCreateCategory/><a>Create Category</a></div></div></NavLink>
                                        <NavLink to="expensehub/hub-settings"><div className={activeHubSettings ? (expandExpenseHubItems ? 'expand-items-active' : 'dropped-items') : (expandExpenseHubItems ? 'expand-items' : 'dropped-items')} onClick={() => {activeNavLink(); setActiveHub(true); setActiveHubSettings(true)}}><div className="dashboard-navigation-button-child"><NavExpenseHubSettings/><a>Hub Settings</a></div></div></NavLink>
                                    </div>
                                </div>
                            </div>
                            
                            }
                            
                        </div> 

                        {mobileApp ? 
                        ''
                        :
                        <div className="application-logo">
                            <ExpensibleLogo />
                        </div>
                        }
                    </div>

                    <div className="application-content-container">
                        <div className="application-content">
                        <Routes basename="/dashboard">
                            <Route path="" element={<AppHome loading={loading} expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories}/>} />
                            <Route path="expense" element={<Expense expenses={expenses} userCategories={userCategories} filteredExpenses={filteredExpenses} localAddNewExpense={localAddNewExpense}/>} />
                            <Route path="analytics" element={<Analytics expenses={expenses} filteredExpenses={filteredExpenses} filteredCategories={filteredCategories} />} />
                            <Route path="reports" element={<Reports />} />
                            {/* In the company tab */}
                            <Route path="company/profile" element={<Profile/>} />
                            <Route path="company/teams" element={<Teams />} />
                            {/* In the expenseHub tab */}
                            <Route path="expensehub/create-category" element={<CreateCategory />} />
                            <Route path="expensehub/hub-settings" element={<HubSettings expenses={expenses} userCategories={userCategories} />} />
                        </Routes>
                        </div>
                    </div>

                </div> 
            
        </div>
    )
};